// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
    <sub-header header="'Non PRN payments'"></sub-header>

    <h2 class="section-header">SSS loans and other payments</h2>
    <ng-form name="\$ctrl.commandForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Payment type:</td>
          <td>
            <select name="paymentType"
                    class="form-control"
                    ng-model="\$ctrl.payment.paymentType"
                    ng-options="paymentType | translate:'SSS_PAYMENT_TYPE' for paymentType in \$ctrl.paymentTypes | orderBy"
                    ng-change="\$ctrl.onPaymentTypeChange()"
                    required>
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Payor type:</td>
          <td>
            <select name="payorType"
                    class="form-control"
                    ng-model="\$ctrl.payment.payorType"
                    ng-options="payorType | translate:'SSS_PAYOR_TYPE' for payorType in \$ctrl.availablePayorTypes()"
                    ng-change="\$ctrl.onPayorTypeChange()"
                    required>
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Payor name:</td>
          <td>
            <input name="payorName"
                   type="text"
                   ng-model="\$ctrl.payment.payorName"
                   required/>
          </td>
        </tr>
        <tr ng-if="\$ctrl.showCrn()">
          <td></td>
          <td>CRN:</td>
          <td>
            <input
                   ng-disabled="\$ctrl.isFieldDisabled('crn')"
                   ng-required="\$ctrl.isFieldRequired('crn')"
                   ui-mask="9999-9999999-9"
                   name="crn"
                   type="text"
                   ng-model="\$ctrl.payment.crn"/>
          </td>
        </tr>
        <tr ng-if="\$ctrl.showLoanAccountNumber()">
          <td></td>
          <td ng-if="\$ctrl.payment.payorType !== 'EMPLOYER'">Loan account number:</td>
          <td ng-if="\$ctrl.payment.payorType === 'EMPLOYER'">Employer No.:</td>
          <td class="validation-container">
            <input name="loanAccountNumber"
                   type="text"
                   ng-required="\$ctrl.isFieldRequired('loan')"
                   ng-disabled="\$ctrl.isFieldDisabled('loan')"
                   ng-model="\$ctrl.payment.loanAccountNumber"
                   ng-pattern="\$ctrl.loanAccountNumberPattern()"
                   ui-mask="{{\$ctrl.ssLoanMask()}}"
                   ui-validate="{loanChecksum: '\$ctrl.validateSSLoanNumberChecksum(\$value)'}"
                   ui-validate-watch="'\$ctrl.payment.paymentType'" />
            <div ng-if="\$ctrl.payment.payorType !== 'EMPLOYER' && \$ctrl.commandForm.loanAccountNumber.\$invalid">Invalid account number</div>
            <div ng-if="\$ctrl.payment.payorType === 'EMPLOYER' && \$ctrl.commandForm.loanAccountNumber.\$invalid">Invalid ER ID Number</div>
          </td>
        </tr>
        <tr ng-if="\$ctrl.showSocialSecurityNumber()">
          <td></td>
          <td>Social security number:</td>
          <td class="validation-container">
            <input name="socialSecurityNumber"
                 type="text"
                 ng-required="\$ctrl.isFieldRequired('ssn')"
                 ng-disabled="\$ctrl.isFieldDisabled('ssn')"
                 ng-model="\$ctrl.payment.socialSecurityNumber"
                 ng-pattern="\$ctrl.ssNumberPattern()"
                 ui-mask="{{\$ctrl.ssLoanMask()}}"
                 ui-validate="{sSChecksum: '\$ctrl.validateSSLoanNumberChecksum(\$value)'}"
                 ui-validate-watch="'\$ctrl.payment.paymentType'"/>
            <div ng-if="\$ctrl.commandForm.socialSecurityNumber.\$invalid">Invalid SSS number</div>
          </td>
        </tr>
        <tr ng-if="!\$ctrl.hideStartingEndingPeriod()">
          <td></td>
          <td>Starting period:</td>
          <td>
            <input
                ng-if="!\$ctrl.getFixedDate()"
                name="startingPeriod"
                moment-picker
                ng-model="\$ctrl.payment.startingPeriod"
                max-date="\$ctrl.payment.endingPeriod"
                max-view="year"
                min-view="decade"
                format="YYYY MMM"
                start-view="year"
                change="\$ctrl.onStartingPeriodChange()"
                ng-required="\$ctrl.isDateRequired() || \$ctrl.payment.endingPeriod"/>

            <input
                ng-if="\$ctrl.getFixedDate()"
                name="startingPeriod"
                ng-value="\$ctrl.getFixedDate().format('YYYY MMM DD')"
                disabled/>
          </td>
        </tr>
        <tr ng-if="!\$ctrl.hideStartingEndingPeriod()">
          <td></td>
          <td>Ending period:</td>
          <td>
            <input
                ng-if="!\$ctrl.getFixedDate()"
                name="endingPeriod"
                moment-picker
                ng-model="\$ctrl.payment.endingPeriod"
                min-date="\$ctrl.payment.startingPeriod"
                max-view="year"
                min-view="decade"
                format="YYYY MMM"
                start-view="year"
                ng-required="\$ctrl.isDateRequired() || \$ctrl.payment.startingPeriod"/>
            <input
                ng-if="\$ctrl.getFixedDate()"
                name="startingPeriod"
                ng-value="\$ctrl.getFixedDate().format('YYYY MMM DD')"
                disabled/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>SS amount:</td>
          <td>
            <cash ng-model="\$ctrl.payment.ssAmount"
              ui-validate="{sSAmount: '\$ctrl.validateSSAmount(\$value)'}"
              ui-validate-watch="['\$ctrl.payment.paymentType', '\$ctrl.payment.payorType']"
              ng-required="true"
              ng-if="!\$ctrl.getFixedSSAmount()"
              name="ssAmount"
              min="0.01">
            </cash>

            <cash ng-if="\$ctrl.getFixedSSAmount()"
              value="\$ctrl.getFixedSSAmount()"
              ng-disabled="true"></cash>
          </td>
        </tr>
        <tr ng-if="\$ctrl.showECAmount()">
          <td></td>
          <td>EC amount:</td>
          <td>
            <cash name="ecAmount"
              ng-model="\$ctrl.payment.ecAmount"
              ui-validate="{eCAmount: '\$ctrl.validateECAmount(\$value)'}"
              ui-validate-watch="'\$ctrl.payment.paymentType'"
              ng-required="true"></cash>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button
          type="button"
          class="misc-transaction__cancel btn btn-warning"
          ng-disabled="\$ctrl.commandForm.\$pristine"
          ng-click="\$ctrl.cancelChanges()">
          Cancel
        </button>
        <button
          type="submit"
          class="misc-transaction__save btn btn-success"
          ng-disabled="\$ctrl.commandForm.\$invalid"
          ng-click="\$ctrl.save()">
          Submit payment
        </button>
      </div>
    </ng-form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/sss-offline-payment/sss-offline-payment.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;